function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
  id: "grc-logo-big-b",
  cx: 30.514,
  cy: 29.794,
  r: 29.72
}), /*#__PURE__*/React.createElement("filter", {
  id: "grc-logo-big-a",
  width: "234.6%",
  height: "234.6%",
  x: "-67.3%",
  y: "-33.6%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 20,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 10
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  values: "0 0 0 0 0.145098039 0 0 0 0 0.0588235294 0 0 0 0 0.541176471 0 0 0 0.2 0"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "grc-logo-big-c",
  x1: "105.995%",
  x2: "-17.154%",
  y1: "50%",
  y2: "50%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#18BBEF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#0E4284"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "grc-logo-big-d",
  x1: "160.915%",
  x2: "-31.06%",
  y1: "92.502%",
  y2: "9.12%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#18BBEF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#0E4284"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "grc-logo-big-e",
  x1: "102%",
  x2: "48.931%",
  y1: "67.326%",
  y2: "33.245%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#18BBEF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#0E4284"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "grc-logo-big-f",
  x1: "28.272%",
  x2: "82.506%",
  y1: "-1.078%",
  y2: "84.249%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#18BBEF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#0E4284"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "grc-logo-big-g",
  x1: "50.006%",
  x2: "50.006%",
  y1: "17.445%",
  y2: "78.838%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#18BBEF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#0E4284"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "grc-logo-big-h",
  x1: "0%",
  y1: "50%",
  y2: "50%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#18BBEF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#0E4284"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(40.71 .292)"
}, /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  filter: "url(#grc-logo-big-a)",
  xlinkHref: "#grc-logo-big-b"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#FFF",
  xlinkHref: "#grc-logo-big-b"
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#grc-logo-big-c)",
  fillRule: "nonzero",
  d: "M30.425 33.357h8.773l2.13-3.694h-12.98z",
  transform: "translate(40.71 .292)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#grc-logo-big-d)",
  fillRule: "nonzero",
  d: "M34.525 33.357l-2.152 3.731 2.334 4.048 4.122-7.142 2.499-4.33z",
  transform: "translate(40.71 .292)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#grc-logo-big-e)",
  fillRule: "nonzero",
  d: "M30.727 19.974l-16.194.004 8.102 14.024 8.1 14.023 2.3-3.988-2.919-5.169-3.932-6.807-4.547-7.868 9.09-.003 9.09-.004-1.345 2.331h4.67l3.779-6.55z",
  transform: "translate(40.71 .292)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#grc-logo-big-f)",
  fillRule: "nonzero",
  d: "M37.042 37.055h-4.67l6.104 10.71 2.603-3.62z",
  transform: "translate(40.71 .292)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#grc-logo-big-g)",
  fillRule: "nonzero",
  d: "M50.704 37.736C46.746 47.53 36.272 53.01 25.97 50.676 15.668 48.345 8.576 38.887 9.224 28.344 9.872 17.8 18.067 9.28 28.578 8.226c10.51-1.054 20.235 5.666 22.964 15.87h4.234c-2.788-12.535-14.413-21.08-27.21-20C15.77 5.176 5.742 15.55 5.094 28.374 4.446 41.2 13.378 52.53 26 54.894c12.622 2.363 25.049-4.967 29.086-17.158h-4.383z",
  transform: "translate(40.71 .292)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#grc-logo-big-h)",
  fillRule: "nonzero",
  d: "M39.816 24.186H21.648l-7.115-4.208H46.92z",
  transform: "translate(40.71 .292)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M7.174 87.804h-1.63c-.261-.717-.783-1.108-1.566-1.108-1.239.13-1.891.978-1.956 2.674.065 1.695.782 2.608 2.087 2.673.848 0 1.37-.326 1.63-1.108V89.76H3.652v-.978H7.24v2.608c-.456 1.044-1.5 1.566-3.13 1.566C1.76 92.89.587 91.652.457 89.239c.065-2.282 1.239-3.522 3.521-3.652 1.63.13 2.74.848 3.196 2.217zm7.304 5.087H9.196v-7.108h1.565v6.13h3.717zm8.87-3.521c-.13 2.282-1.305 3.521-3.522 3.652-2.217-.13-3.391-1.37-3.522-3.652.13-2.348 1.305-3.587 3.522-3.718 2.152.196 3.326 1.435 3.522 3.718zm-1.63 0c-.066-1.761-.653-2.61-1.892-2.674-1.239.065-1.891.978-1.956 2.674.065 1.695.717 2.608 1.956 2.673 1.24 0 1.891-.913 1.891-2.673zm7.042 3.521h-3.52v-7.108h3.586c1.5 0 2.283.587 2.283 1.76 0 .783-.392 1.37-1.174 1.63.913.262 1.435.784 1.435 1.631.13 1.435-.718 2.153-2.61 2.087zm-.325-6.065H26.87v1.891h1.63c.717 0 1.043-.326 1.043-.978 0-.652-.39-.913-1.108-.913zm.195 3.065h-1.76v2.087h1.76c.783 0 1.24-.326 1.174-1.043.066-.718-.326-1.044-1.174-1.044zm11.479 3h-1.63l-.588-1.63h-2.739l-.587 1.63h-1.63l2.674-7.108H37.5l2.609 7.108zm-3.587-5.608l-1.044 3h2.087l-1.043-3zm10.565 5.608h-5.283v-7.108h1.566v6.13h3.717zm9.587-2.804l2.087 2.804h-1.826l-1.957-2.739H54v2.74h-1.565v-7.11h3.391c1.696 0 2.544.718 2.544 2.218.065 1.24-.522 1.957-1.696 2.087zM54 86.827v2.347h1.5c.913 0 1.304-.326 1.304-1.109 0-.848-.391-1.304-1.304-1.239H54zm12 6.064h-5.543v-7.108H66v.978h-3.978v1.956h3.717v1.044h-3.717v2.152H66zm10.76-7.108l-1.564 7.108H73.37l-1.24-5.087-1.239 5.087H69l-1.565-7.108h1.63l.978 5.478 1.174-5.478h1.761l1.24 5.478.912-5.478zm8.414 7.108h-1.696l-.587-1.63h-2.739l-.587 1.63h-1.63l2.674-7.108H82.5l2.674 7.108zm-3.652-5.608l-1.044 3h2.087l-1.043-3zm9.587 2.804l2.087 2.804H91.37l-1.957-2.739h-.978v2.74H86.87v-7.11h3.39c1.697 0 2.544.718 2.544 2.218.066 1.24-.521 1.957-1.695 2.087zm-2.674-3.26v2.347h1.5c.913 0 1.304-.326 1.304-1.109 0-.848-.391-1.304-1.304-1.239h-1.5zm8.739 6.064H94.89v-7.108h2.218c2.674-.066 3.978 1.108 3.913 3.521.13 2.479-1.174 3.718-3.848 3.587zm-.13-6.065h-.587v5.152h.586c1.63.065 2.414-.848 2.348-2.674.066-1.695-.717-2.543-2.348-2.478zm5.739 4.891v-1.239c.782 1.109 1.76 1.63 2.804 1.63.978 0 1.5-.39 1.5-1.108 0-.587-.457-.913-1.37-1.109-2.021-.326-2.934-1.108-2.804-2.282.065-1.305.978-1.892 2.674-1.957 1.696.065 2.609.783 2.87 2.218h-1.5c-.261-.783-.718-1.174-1.37-1.174-.717 0-1.109.326-1.109.913-.065.521.392.913 1.24 1.043 1.956.391 2.869 1.109 2.869 2.218 0 1.434-.913 2.087-2.87 2.087-1.174.13-2.152-.327-2.934-1.24zm17.543-3.652h-1.565c-.196-.848-.718-1.304-1.5-1.304-1.24.065-1.826.913-1.891 2.674.065 1.695.782 2.543 2.217 2.608.913.066 1.76-.456 2.543-1.565v1.37c-.652.782-1.63 1.174-2.87 1.174-2.217-.13-3.325-1.305-3.456-3.652.13-2.283 1.24-3.522 3.392-3.653 1.76 0 2.804.783 3.13 2.348zm3.522 4.826h-1.565v-7.108h1.565zm8.217-6.065h-2.348v6.065h-1.565v-6.065h-2.348v-.978h6.261zm8.675-1.043l-2.87 4.304v2.74h-1.566v-2.74l-2.804-4.304h1.826l1.826 3 1.761-3zm-94.127 13.02h.815v2.857h3.202v.756h-3.202v4.37h3.79v.698H37.233v-.698h3.73v-4.37H37.82v-.763h3.144v-2.856h.815v2.856h4.84l-.007-2.85zm-4.429 9.907l.58.652a62.227 62.227 0 0 1-4.832 3.032 2.537 2.537 0 0 0-.58-.697 32.21 32.21 0 0 0 4.832-2.987zm-.41-6.294v4.37h4.839v-4.37h-4.84zm3.789 6.933l.521-.652a205.967 205.967 0 0 0 4.663 2.974l-.521.652c-.661-.466-1.652-1.107-2.974-1.924-.778-.47-1.341-.82-1.69-1.05zm15.567 1.513l-.176-.757.874-.176a11.39 11.39 0 0 1 1.109-.235v-4.487h-1.63v-.697h1.63v-3.79H61.07v-.697h4.37v.698h-1.807v3.789h1.63v.697h-1.63v4.311c.196-.039.483-.117.874-.234.336-.056.667-.135.992-.235-.005.253.014.507.058.756-1.126.24-2.602.592-4.428 1.057zm5.217-4.428h2.61l.462-1.63h-3.495v-.699h9.221v.698h-4.891l-.522 1.63h4.84V111c.039 1.008-.407 1.493-1.338 1.454h-1.167a2.27 2.27 0 0 0-.176-.756c.387.039.756.058 1.109.058.582.04.854-.232.815-.815v-3.809h-1.807v4.253h-.697v-4.253h-1.748v4.605h-.757v-4.605h-1.748v5.413h-.697l-.014-6.11zm.235-3.913v-2.974h.737v2.27h2.74v-3.203h.697v3.202h2.74v-2.27h.756v2.975h-7.67zm18.385 7.526l-.176-.816c.338-.069.67-.167.991-.293.387-.117.679-.196.874-.235v-5.713h-1.689v-.698h1.69v-3.671h.756v3.671h1.571v.698h-1.571v5.478c.543-.195 1.067-.37 1.571-.521a2.98 2.98 0 0 0 .06.756c-1.514.47-2.873.918-4.077 1.344zm9.326-11.42h.815c0 1.087.02 2.078.06 2.974h3.73v.698h-3.73c.083 1.934.3 3.86.651 5.765a18.704 18.704 0 0 0 1.865-3.965l.757.293a23.06 23.06 0 0 1-2.387 4.722c.435 1.596.94 2.41 1.513 2.446.235 0 .385-.216.463-.653.154-.67.252-1.353.294-2.04.232.141.488.24.756.293a16.213 16.213 0 0 1-.352 2.041c-.157.74-.507 1.109-1.05 1.109-.93.078-1.667-.737-2.21-2.446a25.565 25.565 0 0 1-2.505 2.504 5.504 5.504 0 0 0-.652-.58 15.685 15.685 0 0 0 2.915-2.857 31.957 31.957 0 0 1-.815-6.645h-3.966v2.27h2.798c0 1.982-.039 3.419-.117 4.31a1.474 1.474 0 0 1-1.63 1.63h-.875a2.778 2.778 0 0 0-.176-.756h.933a.874.874 0 0 0 1.05-.991c.04-.583.059-1.728.059-3.437h-2.042a21.104 21.104 0 0 1-.404 4.31 9.867 9.867 0 0 1-1.572 2.916 2.21 2.21 0 0 0-.652-.522 6.333 6.333 0 0 0 1.513-2.68c.284-1.38.402-2.787.352-4.194v-3.554h4.722a13.565 13.565 0 0 1-.059-1.513 28.25 28.25 0 0 1-.052-1.448zm1.572.991l.463-.463c.533.328 1.04.7 1.513 1.109.123.09.241.188.352.293l-.522.58a97.57 97.57 0 0 0-1.806-1.519z"
}));

const SvgGrcLogoBig = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 113,
    viewBox: "0 0 141 113",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGrcLogoBig, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/grc-logo-big.fb2ef8f7.svg";
export { ForwardRef as ReactComponent };